import React from 'react';
import Link from 'next/link';
import dynamic from 'next/dynamic';
import CircularProgress from '@material-ui/core/CircularProgress';
import { formatDate } from '../../../utils/dateFormat';

const MaterialTable = dynamic(() => import('material-table'), {
  ssr: false,
  loading: () => <CircularProgress />,
});

export const UpcomingEventsTable = (props) => {
  props.rows.splice(5);
  return (
    <>
      <MaterialTable
        columns={[
          {
            title: 'Form',
            field: 'formTitle',
            width: '15%',
            cellStyle: {
              padding: '15px 0 15px 46px',
            },
          },
          {
            title: 'Patient',
            field: 'patient.externalId',
            render: (rowData) => (
              <Link href='/patient/[pid]' as={`/patient/${rowData.patient.id}`}>
                <a className='single_Link'>{rowData.patient.externalId}</a>
              </Link>
            ),
            width: '15%',
            cellStyle: {
              padding: '15px 0 15px 46px',
            },
          },
          {
            title: 'Study',
            field: 'form.study.name',
            width: '15%',
            cellStyle: {
              padding: '15px 0 15px 46px',
            },
          },
          {
            title: 'Due Date',
            field: 'due',
            type: 'date',
            render: (rowData) => formatDate(rowData.due, 'yyyy/MM/dd'),
            width: '20%',
            cellStyle: {
              padding: '15px 0 15px 46px',
            },
          },
        ]}
        data={props.rows}
        options={{
          search: false,
          padding: 'default',
          paging: false,
          showTitle: false,
          toolbar: false,
          sorting: false,
          draggable: false,
          headerStyle: {
            padding: '30px 0 30px 46px',
            color: '#707070',
          },
        }}
      />
    </>
  );
};
